var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCubixPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0L25.1913 6.75V20.25L13.5 27L1.80866 20.25V6.75L13.5 0Z",
    fill: "#AEF800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9277 10.7686L18.751 8.71277L16.3314 12.8891L18.7672 17.072L19.9277 15.0817L18.6818 12.9045L19.9277 10.7686Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36365 15.0162L8.5403 17.072L10.9606 12.8957L8.5241 8.71277L7.36365 10.7031L8.60952 12.8802L7.36365 15.0162Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0451 8.59119L14.92 10.7279L14.9163 10.7227H12.4113L11.2442 8.59119H8.81653L11.2442 12.7167L16.0465 12.7248L18.4411 8.59119H16.0451Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2125 17.1821L12.3377 15.0447L12.3413 15.0506H14.8463L16.0134 17.1821H18.4411L16.0134 13.0558L11.2111 13.0485L8.81653 17.1821H11.2125Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubixPolygon);
export default __webpack_public_path__ + "static/media/cubix-polygon.7a278d98d164a6267d37840ee26c793e.svg";
export { ForwardRef as ReactComponent };